import React from "react";

const ContentMangementSvgIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M0.416992 2.54297H6.08366V0.417969H7.50032V14.5846H6.08366V11.7513H3.25033V9.6263H6.08366V8.20963H1.83366V6.08463H6.08366V4.66797H0.416992V2.54297ZM8.91699 2.54297H11.042V4.66797H8.91699V2.54297ZM8.91699 6.08463H12.4587V8.20963H8.91699V6.08463ZM8.91699 9.6263H14.5837V11.7513H8.91699V9.6263Z"
        fill="#646464"
      />
    </svg>
  );
};

export default ContentMangementSvgIcon;
